"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CATEGORIES_HASH = void 0;
exports.GET_CATEGORIES_HASH = `
  {
    categories
  }
`;
//# sourceMappingURL=categories-queries.js.map